<div class="page-container">
    <div class="banner-section" [ngStyle]="{ 'background-image': 'url(' + bannerImageUrl + ')' }">
      <div class="banner-text">
        <h1>{{bannerHeading}}</h1>
        <p>{{bannerDescription}}</p>
        <button class="button bannerBtn" (click)="buttonAction()"
         appTrackClick 
          [buttonProps]="{
              title:'hitmaker_begin_the_journey_top_button',
              feature_context:'HITMAKER'
          }"
        >{{buttonName}}</button>
      </div>
    </div>
  
    <div class="cardSection">
        <div class="cards-container">
            <div class="card-wrapper" *ngFor="let card of cards">
              <h3 class="card-heading">{{ card.title }}</h3>
              <div class="card">
                <img [src]="card.image" alt="Image" />
                <div class="card-description">
                  <p>{{ card.description }}</p>
                </div>
              </div>
            </div>
          </div>
        <button class="button" (click)="buttonAction()"
          appTrackClick 
          [buttonProps]="{
              title:'hitmaker_begin_the_journey_bottom_button',
              feature_context:'HITMAKER'
          }"
        >{{buttonName}}</button>
    </div>
  </div>